var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.avatarUrl)?_c('div',{staticClass:"avatar-shield"},[_c('img',{staticClass:"shield-bg dead-center",attrs:{"src":require("@/assets/img/avatar/avatar-selection-bg.png")}}),_c('img',{staticClass:"avatar-img dead-center",attrs:{"src":_vm.avatarUrl}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }